export default "__VITE_ASSET__DpoUTdj3__"